import { FC } from 'react';
import { BreadCrumbComponent } from '@components/breadCrumb';
import YoutubeEmbed from '@components/youtubePlayer/YoutubeEmbed';
import { useWindowSize } from '@shared/utils/hooks';
import breakpoint from '../../../../../shared/assets/breakpoint.json';
import { CoverBackground, CoverContainer, CoverContent, CoverImage } from './Cover.style';
interface Props {
  coverImg: string;
  coverVdo: string;
  pageName: string;
}
const RecipeCover: FC<Props> = ({
  coverImg,
  coverVdo,
  pageName
}: Props) => {
  const {
    width
  } = useWindowSize();
  return <CoverContainer>
            <div className="overlay-cover" />
            <CoverBackground $imageUrl={coverImg} />
            <CoverContent>
                {width > breakpoint.md && <BreadCrumbComponent pageName={pageName} />}

                {coverVdo ? <YoutubeEmbed youtubeUrl={coverVdo} /> : <CoverImage src={coverImg} alt="cover-img" width={1140} height={641} />}
            </CoverContent>
        </CoverContainer>;
};
export default RecipeCover;